import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-curtain', 'showLess', 'Показать меньше');
Labels.set('ui-curtain', 'showMore', 'Показать больше');
Labels.set('ui-curtain', 'completedStep', 'Шаг выполнен');
